import { ReduxUtils, CodeSnippetBackgroundStyle } from 'UI-Dash-Commons-UI';
import * as constants from './constants';
import DspDocsState from '../types/DspDocsState';

const initialCampaignManagementAPIDocsReducer: DspDocsState = {
    codeSnippetBackgroundStyle: CodeSnippetBackgroundStyle.LIGHT,
};

const onToggleCodeSnippetBackgroundStyle = ( state: DspDocsState, action: any ): DspDocsState =>
    ( {
        ...state,

        codeSnippetBackgroundStyle: action.codeSnippetBackgroundStyle,
    } );

const DspDocsPageReducer = ReduxUtils.createReducer( initialCampaignManagementAPIDocsReducer, {
    [ constants.ACTION_ON_TOGGLE_CODE_SNIPPET_BACKGROUND_STYLE]: onToggleCodeSnippetBackgroundStyle,
} );

export default DspDocsPageReducer;
